export type StudentsViewState = 'loading' | 'error' | 'empty' | 'filtered-empty' | 'ready';

type StudentsViewStateInput = {
  isLoading: boolean;
  hasError: boolean;
  studentCount: number;
  visibleStudentCount: number;
};

export function getStudentsViewState({
  isLoading,
  hasError,
  studentCount,
  visibleStudentCount,
}: StudentsViewStateInput): StudentsViewState {
  if (studentCount === 0 && isLoading) return 'loading';
  if (hasError) return 'error';
  if (studentCount === 0) return 'empty';
  if (visibleStudentCount === 0) return 'filtered-empty';
  return 'ready';
}
